import { render, staticRenderFns } from "./BankReconciliation.vue?vue&type=template&id=2b2d3bc6"
import script from "./BankReconciliation.vue?vue&type=script&lang=js"
export * from "./BankReconciliation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports